import { render, staticRenderFns } from "./revoke-group-admin-access-modal.vue?vue&type=template&id=4c2095b0&"
import script from "./revoke-group-admin-access-modal.vue?vue&type=script&lang=js&"
export * from "./revoke-group-admin-access-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports